import {IAbasecAccount, IAutogiro, IContribution, IItem, ILoan, IOwner} from './types'
import {IAccount, IInsurance} from '@sparbanken-syd/teradata-user'
import {ResolveFn} from '@angular/router'
import {inject} from '@angular/core'
import {Calculus} from '../services/calculus/calculus'

export const HOME_PATH = 'home'
export const GUIDE_PATH = 'guide'
export const LIST_PATH = 'list'
export const SETTINGS_PATH = 'settings'
export const LOGIN_PATH = 'login'

export const ADMIN_ROLE = 'profitCalcUser'

export const migrateItem = (input: Partial<IItem>): IItem => {
  input.orgs ??= []
  input.loans ??= input.collections!.loans as any
  return input as IItem
}

/**
 * "Item" is what we store in our database
 */
export const getItem = (sub = ''): IItem => ({
  id: '',
  version: 0,
  sub,
  loans: [],
  orgs: [],
  owners: [],
  collections: {},
  createdAt: Date.now(),
  updatedAt: Date.now(),
  user: {name: ''},
  approvalStatus: 'created'
})

export const getDefaultLoan = (amount = 0, discount = 0): ILoan => ({
  accountNo: '',
  owner: '',
  percent: 0,
  isOwner: false,
  productName: '',
  productId: 'l753',
  start: 0,
  fixEnd: 0,
  amount,
  interest: 0,
  discount,
  profile: 0,
  binding: 3,
  amortization: 0,
  campaign: null
})

export const getDefaultAccount = (sub = '', product = ''): IAccount => ({
  sub,
  name: '',
  percentage: 0,
  accountNo: '',
  interest: 0,
  balance: 0,
  product,
  productName: '',
  productType: '',
  arrangementId: ''
})

export const getDefaultOwner = (name = ''): IOwner => ({
  sub: '',
  name
})

export const getDefaultInsurance = (name = '', value = 0): IInsurance => ({
  name,
  value,
  sub: '',
  monthly: 0
})

export const getDefaultInvestment = (name = '', value = 0): IAbasecAccount => ({
  accountNo: 0,
  value,
  name,
  sub: ''
})

export const getDefaultAutogiro = (amount = 0): IAutogiro => ({
  amount,
  sub: ''
})

export const getDefaultContribution = (tb = 0): IContribution => ({
  tb,
  sub: '',
  name: ''
})

/**
 * The defaults fetched 2026-02-19
 */
export const getDefaultInterests = () => (
  {
    l753: {
      3: 3.42,
      12: 3.34,
      24: 3.43,
      36: 3.58,
      48: 3.92,
      60: 4.17
    },
    borgo: {
      3: 3.42,
      12: 3.34,
      24: 3.43,
      36: 3.58,
      48: 3.92,
      60: 4.17,
      84: 4.32,
      120: 4.62
    },
    fixed: {
      i83: 2
    }
  }
)

export const LoanProductMap = new Map<string, string>([
  ['l750', 'Bolån bunden ränta'],
  ['l751', 'Grönt bolån'],
  ['l752', 'Sparbanken Syd bolån'],
  ['l753', 'Syd bostadslån'],
  ['l754', 'Syd lån l754 - SBAB'],
  ['l755', 'Syd ???'],
  ['l756', 'Syd Digitalt bolån'],
  ['Borgo', 'Borgo']
])

export const AccountProductMap = new Map<string, string>([
  ['i14', 'Sparkonto Personal'],
  ['i15', 'Private banking konto'],
  ['i16', 'Specialinlåning'],
  ['i24', 'Fasträntekonto 3 mån'],
  ['i25', 'Fasträntekonto 6 mån'],
  ['i26', 'Fasträntekonto 1 år'],
  ['i27', 'Fasträntekonto 1,5 år'],
  ['i28', 'Fasträntekonto 2 år'],
  ['i29', 'Fasträntekonto 3 år'],
  ['i30', 'Fasträntekonto 4 år'],
  ['i31', 'Fasträntekonto 5 år'],
  ['i32', 'Fasträntekonto 3 mån auto'],
  ['i51', 'Österlenkonto (i51)'],
  ['i53', 'Österlenkonto (i53)'],
  ['i83', 'E-sparkonto'],
  ['i84', 'Hästkonto'],
  ['k11', 'Företagskonto'],
  ['k12', 'Servicekonto'],
  ['k17', 'Personalkonto'],
  ['k270', 'Privatkonto'],
  ['k271', 'Privatkonto'],
  ['k27', 'Privatkonto'],
  ['l73', 'Syd Konsumentlån'],
  ['l113', 'Personallån Bolån'],
  ['kred001', 'Visa Betal- & kreditkort']
])

/** These "loans", private loans */
export const PrivateLoans = ['l73', 'l113']
/**
 * This should be a list of all savings accounts
 * that are counted for profit.
 */
export const SavingsAccounts = [
  'i14', 'i15', 'i83', 'i84', 'i53', 'i51', 'i24', 'i25', 'i26', 'i27', 'i28', 'i29', 'i30', 'i31', 'i32']

/**
 * Special list for detecting precense of Private banking.
 */
export const PrivateBankingAccounts = ['i15']

export const CreditCardAccounts = ['kred001']

/**
 * Never include bostadslån
 */
export const AccountsBlackList = [...LoanProductMap.keys()]

/**
 * For Leo
 */
export const KapitalForsakringar = ['kapitalförsäkring']
export const BetalSkyddItems = ['betalskydd']
// We make this impossible to detect automatically, note the little space in the beginning.
export const LivforsakringarItems = [' Livförsäkring']


/**
 * Not sure this is really needed, looking into it.
 */
export const calculusResolver: ResolveFn<Calculus> = () => {
  return inject(Calculus)
}

